import * as React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import useGetEnterpriseMemberDetails from '../api/useGetEnterpriseMemberDetails';
import InlineLoader from '../../../components/InlineLoader';

const MemberDetailsByMemberId: React.FC = () => {
    const params = useParams<Required<{ member_id: string; id: string }>>();
    const [searchParams] = useSearchParams();

    const navigate = useNavigate();

    const { data: enrollmentResponse, isFetching } = useGetEnterpriseMemberDetails({
        member_id: params.member_id ? +params.member_id : 0
    });

    React.useEffect(() => {
        if (!isFetching && enrollmentResponse?.data) {
            const route = searchParams.get('route') || 'details';
            if (params.id) {
                navigate(
                    `/organizations/${params.id}/members/${enrollmentResponse.data.id}/${route}`
                );
            } else {
                navigate(
                    `/organizations/${enrollmentResponse.data.organization.id}/members/${enrollmentResponse.data.id}/${route}`
                );
            }
        }
    }, [enrollmentResponse, params, isFetching]);

    return <InlineLoader />;
};

export default MemberDetailsByMemberId;
